import React, { Component } from 'react';
import { SmallButton } from "./common/Buttons";
import { ChooseMethod } from "./common/ChooseMethod";
import { Button } from "react-bootstrap";
import styled from 'styled-components';
import mfaTextImg from "../images/mfa-text.png";
import mfaVoiceImg from "../images/mfa-voice.png";
import retryImg from "../images/retry-ico.svg";
import { t } from "./helper/ClientAppLocalizer";


const StyledInput = styled.input`
  margin-top: 20px;
  width:320px;
  
`
export class PhoneCode extends Component {
    static displayName = PhoneCode.name;

    constructor(props) {
        super(props);
        this.state = {
            method: props.method,
            number: props.number,
            phoneNumberId: props.phoneNumberId,
            token: "",
            codeSent: false,
            errorMessage: "",
            isLoginEnabed: false
        };

        this.verifyCode = this.verifyCode.bind(this);
        this.setToken = this.setToken.bind(this);
        this.onKeyDown= this.onKeyDown.bind(this);
        this.handleSendCode = this.handleSendCode.bind(this);
    }

    componentDidMount() {
       //when we mount the first time we're going to kick off the first code
        this.handleSendCode();
    }

    verifyCode() {
        const txtIncorrectCodeTryAgain = t("PhoneCode.IncorrectCodeTryAgain");
        fetch('/api/MFA/verifyPhoneToken', {
            method: 'post',
            headers: new Headers({ 'content-type': 'application/json' }),
            body: JSON.stringify(
                {
                    authenticationMethod: this.state.method,
                    phoneNumberId: this.state.phoneNumberId,
                    token: this.state.token
                }
                )
            })
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                }
                else {
                    throw new Error(results.statusText);
                }

            }).then(data => {
                if (data.success) {
                    this.setState({ errorMessage: "" });
                    this.props.verificationComplete(data);
                } else {
                    this.setState({ errorMessage: txtIncorrectCodeTryAgain });
                    this.props.allowRetry(data.allowRetry, txtIncorrectCodeTryAgain, data.returnUrl);
                }
            }).catch(error => {
                this.setState({ error: true });
            });
    }


    handleSendCode() {

        fetch('/api/MFA/sendPhoneVerificationRequest', {
            method: 'post',
            headers: new Headers({ 'content-type': 'application/json' }),
            body: JSON.stringify(
                {
                    authenticationMethod: this.state.method,
                    phoneNumberId: this.state.phoneNumberId
                })
        })
        .then(results => {
            if (results.status === 200) {
                return results.json();
            }
            else {
                throw new Error(results.statusText);
            }

        })
        .then(data => {
            if (data.providerUnavailable) {
                this.props.verificationComplete(data);
            }
            else {
                this.setState({ codeSent: true });
                this.props.requestSent(this.props.method);
            }
        }).catch(error => {
            this.setState({ error: true });
        });
    };
    

    setToken(e) {
        
        this.setState({ token: e.target.value });
        this.setState({ isLoginEnabed: e.target.value.length>=4})
    }
    
    onKeyDown(e)
    {
        if(e.keyCode === 13) {
            this.verifyCode();
        }
    }

    render() {
        const isSms = this.state.method === "sms";
        
        const msg1 = isSms ? t("PhoneCode.EnterSMSCode") : t("PhoneCode.EnterVoiceCode");
        
        const msg2 = isSms ? t("PhoneCode.WeSentAText") : t("PhoneCode.WeAreCalling");

        const msg3 = isSms ? t("PhoneCode.EnterVerificationCode") : t("PhoneCode.ListenToVoiceMsg");

        const msg4 = isSms ? "" : t("PhoneCode.EnterItBelow");
        
        const iconSrc = isSms ? mfaTextImg : mfaVoiceImg;

        const resendCodeText = isSms ? t("PhoneCode.ResendCode") : t("PhoneCode.CallMeWithCodeAgain");

        const warn = t("SystemMessages.CommonWarning");

        return (
            <div>

                <img id="topImage" alt={t("Authy.DayforceLogo")} src={iconSrc} style={{maxHeight:120, maxWidth:120, alignContent: 'center'}}/>

                {this.state.codeSent ? (
                    <div>
                        <div className="mfa-header" style={{ textAlign: "center", marginTop: 10, marginBottom: 10 }}> {msg1} </div>
                        <div id="mfaText2" className="mfa-text" style={{ textAlign: "center" }}> {msg2} </div>
                        <div id="mfaTextNumber" className="mfa-text" style={{ textAlign: "center" }}> {this.state.number} </div>
                        <div id="mfaWarn" className="mfa-text" style={{ textAlign: "center", fontWeight: "bold" }}> {warn} </div>
                        <div id="mfaText3" className="mfa-text" style={{ textAlign: "center", marginTop: 10 }}> {msg3} </div>
                        <div id="mfaText4" className="mfa-text" style={{ textAlign: "center" }}> {msg4} </div>  

                        <div>
                            <StyledInput id={this.state.method + 'InputCode'} type="text" onChange={this.setToken} onKeyDown={this.onKeyDown} maxLength="10"/>

                        </div>
                        {this.state.errorMessage ? <div style={{ marginBottom: 10, color: 'red', fontSize: '90%' }}>{this.state.errorMessage}</div> : ''}
                        <div style={{ marginTop: "20px" }}>
                            <SmallButton id={this.state.method + 'SubmitCode'} onClick={this.verifyCode} disabled={!this.state.isLoginEnabed}>{t("Login")}</SmallButton>
                        </div>

                        <div>

                            <Button id="resendCodeBtn" variant="link" onClick={this.handleSendCode} style={{ color: '#08c', fontSize:12, fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'}}>
                                <img src={retryImg} height="18" alt={t("PhoneCode.ResendCode")} />
                                {resendCodeText}
                            </Button>
                        </div>
                    </div>
                 ) : ''}
                <ChooseMethod changeVerificationMethod={this.props.changeVerificationMethod} lockoutMessage={this.props.lockoutMessage}/>
            </div>
        );
    }
}